import React from 'react';
import { DidomiSDK } from '@didomi/react';
import { useDispatch, useSelector } from 'react-redux';
import { DidomiActionType } from './didomiActionType';
import { IReduxRootState } from '../../app/reduxRootState.interface';

export const DidomiModal: React.FC = () => {
    const dispatch = useDispatch();
    const app = useSelector((state: IReduxRootState) => state.app);
    const DIDOMI_API_KEY = app.appConfig.DIDOMI_API_KEY;
    const DIDOMI_RAKUTEN_VENDOR = app.appConfig.DIDOMI_RAKUTEN_VENDOR;

    const isReady =
        Object.keys(app.clientConfig).length > 0 && Object.keys(app.appConfig).length > 0;
    const onConsentChanged = (consentToken: any) => {
        const status = (window as any).Didomi.getUserConsentStatusForVendor(DIDOMI_RAKUTEN_VENDOR);
        const RAT_ENABLED = status ? true : false;
        dispatch({
            type: DidomiActionType.RAT_APPCONFIG,
            appConfig: { ...app.appConfig, RAT_ENABLED: RAT_ENABLED },
        });
    };

    const onReady = () => {
        const status = (window as any).Didomi.getUserConsentStatusForVendor(DIDOMI_RAKUTEN_VENDOR);
        if (status) {
            dispatch({
                type: DidomiActionType.RAT_APPCONFIG,
                appConfig: { ...app.appConfig, RAT_ENABLED: true },
            });
        }
    };

    return !isReady ? null : (
        <DidomiSDK
            apiKey={DIDOMI_API_KEY}
            gdprAppliesGlobally={true}
            onReady={() => onReady()}
            onConsentChanged={(consentToken) => onConsentChanged(consentToken)}
        />
    );
};
